import { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { appEnv } from '@/app/config/env';
import { storageKeys } from '@/app/constants/storageKeys';
import { PageName } from '@/app/enums/pageName';
import { storage } from '@/app/storage';
import { getIpAddressFromStorage } from '@/app/utils/get-ip-address';
import getProductName from '@/app/utils/getProductName/productName';

const onRequest = (config: InternalAxiosRequestConfig) => {
  const titleProduct = getProductName({ url: window.location.pathname });
  const ip = getIpAddressFromStorage();

  if (!config.headers?.['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
  if (!config.headers?.['x-api-key']) {
    config.headers['x-api-key'] = appEnv.apiKey;
  }
  if (!config.headers?.['Authorization']) {
    config.headers['Authorization'] = `Bearer ${storage.get(storageKeys.ACCESS_TOKEN).trim()}`;
  }

  if (titleProduct && titleProduct in PageName) {
    config.headers['X-Page-Name'] = PageName[titleProduct as keyof typeof PageName];
  }

  if (ip && config.url) {
    const url = new URL(config.url, config.baseURL);
    url.searchParams.set('ipAddress', ip);
    config.url = url.pathname + url.search;
  }

  return config;
};

const onRequestError = (error: AxiosError) => Promise.reject(error);

export { onRequest, onRequestError };
